import React from 'react';
import { cn } from '@/utils/cn';

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({ className, style }) => (
  <div className={cn('animate-pulse rounded bg-neutral-200', className)} style={style} />
);

interface SkeletonGroupProps {
  loading?: boolean;
  children?: React.ReactNode;
  rows?: number;
  avatar?: boolean;
}

const SkeletonGroup: React.FC<SkeletonGroupProps> = ({
  loading = true,
  children,
  rows = 3,
  avatar,
}) => {
  if (!loading && children) return <>{children}</>;

  return (
    <div className="animate-pulse space-y-3 p-2">
      {avatar && <Skeleton className="h-10 w-10 rounded-full" />}
      <Skeleton className="h-4 w-3/4" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-3" style={{ width: `${100 - i * 10}%` }} />
      ))}
    </div>
  );
};

export { Skeleton, SkeletonGroup };
